import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import img_titulo from '../../assets/imgs_sedes_senado/IMG_ABRE_SEDE.png';
import img_next from '../../assets/imgs_sedes_senado/NEXT_IMG_SEDE.png';
import seta from '../../assets/imgs_sedes_senado/ARROW.png';



// Importando imagens dinamicamente
const importImages = async () => {
  const images = {};
  for (let i = 1; i <= 5; i++) {
        images[`img_${i}`] = require(`../../assets/imgs_sedes_senado/IMG_${i}_SEDE.png`);
  }
  return images;
};

export default function SedesSenado() {

    // Força rolagem para o topo ao carregar o componente
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [images, setImages] = useState({});
    
    useEffect(() => {
        importImages().then(setImages);
      }, []);

      useEffect(() => {
        const loadImages = async () => {
            const imgs = await importImages();
            setImages(imgs);
        };

        loadImages();
    }, []);

    const navigate = useNavigate();
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [nextText, setNextText] = useState("PRÓXIMO CONTEÚDO");

    const handleTransition = () => {
        setNextText("O PALÁCIO DO CONGRESSO NACIONAL");
        setIsTransitioning(true);
        setTimeout(() => {
            navigate('/parlamentoNovaCapital'); 
        }, 1000); 
    }

    const [visibleSection, setVisibleSection] = useState('APRESENTAÇÃO');

    const toggleVisibility = (paragrafo) => {
        setVisibleSection(paragrafo);
    };

  return (
    <div className="w-full bg-white flex flex-col justify-center font-medium font-['Lato']">
      <Header cor='preto' />

      <div 
          class="w-full h-auto bg-cover bg-center"
          style={{ backgroundImage: `url(${img_titulo})` }}
      >
        {/* OVERLAY */}
        <div className="w-full h-screen flex flex-col justify-center pt-64 gap-64 pl-24 pr-[33.19vw] pb-28 bg-black/40">
            <div class="w-[56.11vw]">
              <div className="w-[56.11vw] flex-col justify-center items-start inline-flex">
                  <div className="w-[37.56vw] text-white text-3xl font-light font-lato">O PALÁCIO DO CONGRESSO NACIONAL</div>
                  <div className="w-[56.11vw] text-white text-[45px] font-bold font-futura-bold">A SEDE DO SENADO FEDERAL</div>
              </div>

              <div class="w-[28.58vw]">
                <div class="pb-1 text-white text-xl font-medium font-['Lato']">Marcos Magalhães</div>
                <div class="w-[28.58vw] h-[0px] border border-white"></div>
                <div class="text-white text-base font-light font-['Lato']">Historiador e Consultor Legislativo</div>
              </div>
            </div>

            <div class="w-[28.32vw]"> 
              <div className="text-white text-base font-medium font-['Lato'] [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">Construção do Palácio do Congresso Nacional<br/>Arquivo Público do Distrito Federal<br/></div>
            </div>
        </div>
      </div>

      <div
            className="w-full min-h-screen bg-cover bg-center bg-fixed bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_1})` }}
        >
          {/* OVERLAY */}
          <div className="w-full min-h-screen py-[23vh] pl-[7vw] pr-[11.3vw] bg-black/80">
            <div className="w-full box-border gap-5 text-white flex items-start">
                <div className="flex flex-col gap-4 mb-4">
                    <p
                        onClick={() => toggleVisibility('APRESENTAÇÃO')}
                        className={`cursor-pointer text-lg font-normal font-['Lato'] ${
                            visibleSection === 'APRESENTAÇÃO' ? 'text-white' : 'text-white/40'
                        }`}
                    >
                        APRESENTAÇÃO
                    </p>
                    <p
                        onClick={() => toggleVisibility('INTRODUÇÃO')}
                        className={`cursor-pointer text-lg font-normal font-['Lato'] ${
                            visibleSection === 'INTRODUÇÃO' ? 'text-white' : 'text-white/40'
                        }`}
                    >
                        INTRODUÇÃO
                    </p>
                </div>

                {visibleSection === 'APRESENTAÇÃO' && (
                    <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                      O SENADO EM BRASÍLIA<br/><br/>Ao conceber a independência e a democracia no Brasil, José Bonifácio tinha uma visão geopolítica, que incluía Brasília. E foi a estratégia política que impulsionou Juscelino na realização deste sonho.<br/>Em 1958 Israel Pinheiro me mostrou a cidade em construção, um burburinho de máquinas, gentes, cimento, pedras e poeira em contraste com o silêncio das árvores sofridas e contorcidas de um cerrado ainda não derrubado. Os construtores eram a peãozada, mão de obra da miséria, vindos das áreas rurais pobres do Nordeste e de Minas.
                      <br/><br/>Três sonhos. Juscelino, objetivo, olhando os dividendos políticos, Lúcio, o poeta-urbanista imaginando que a cidade criaria um novo cidadão, e Oscar Niemeyer, o artista-escultor das linhas belas e curvas dos monumentos.<br/>Fui o primeiro parlamentar a morar em Brasília. Aqui, sob as cúpulas que marcam a Câmara e o Senado, participei da primeira sessão do Congresso Nacional em Brasília. Há cinquenta anos vivo entre estes espaços, e aqui vi passarem os episódios da instabilidade política até chegar a Nova República e assegurar a estabilidade democrática.<br/> <br/>José Sarney, Presidente do Senado Federal
                    </div>
                )}

              {visibleSection === 'INTRODUÇÃO' && (
                  <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
                    Em seus cinquenta anos de história, a sede do Congresso Nacional constituiu o local do exercício da representação popular. Enfrentou crises políticas no seu nascedouro, viveu 21 anos da ditadura e presenciou a construção da redemocratização do país, refundada na experiência da Constituinte de 1987-88.
                    <br/><br/>Este texto, é um convite para percorrer a História da construção de Brasília pelo viés da História da construção da sede do Poder Legislativo. Destarte, o Brasil passou a ter um espaço físico concebido e construído, na escala mais brilhante, como sede do Congresso Nacional, o palco principal de nossa História recente, tão densa e construída em período brevíssimo.
                  </div>
              )}
            </div>
          </div>
        </div>

        <div 
            class="w-full h-auto bg-cover bg-fixed bg-center bg-no-repeat relative"
            style={{ backgroundImage: `url(${images.img_1})`}}
        >
            <div class="sticky top-0 min-h-screen flex justify-start items-end pb-20 pl-40">
                <div className="w-[28.32vw] text-white text-base font-medium font-['Lato']">Foto aérea do início da construção dos Ministérios. - 1958<br/>UCG/IGPA<br/>Jesco von Puttkamer</div>
            </div>

            <div class="relative w-full min-h-screen sticky top-0">
                <img 
                    src={images.img_2} 
                    alt="JK e Lúcio Costa"
                    className="w-full h-[100vh] object-cover z-10"
                />
                <div className="absolute bottom-20 left-40 w-[28.32vw] text-white text-base font-medium font-['Lato']">JK e Lúcio Costa localizam o Eixo Monumental de Brasília, Jean Manzon<br/>Revista Brasília, abril de 1957, n. 4, p. 7</div>
            </div>

            <div
                className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat relative top-0"
                style={{ backgroundImage: `url(${images.img_3})`}}
            >
                {/* OVERLAY */}
                <div className="w-full h-auto flex flex-col py-72 px-56 bg-[#5a6e64]/80">
                    <div className="w-[64.32vw]">
                        <span class="text-white text-xl font-bold font-lato">À Brasília de Oscar Niemeyer (1975)<br/></span><span class="text-white text-xl font-medium font-['Lato']"> <br/>Eis casas-grandes de engenho,<br/>horizontais, escancaradas,<br/>onde se existe em extensão<br/>e a alma todoaberta se espraia<br/> <br/>Não se sabe é se o arquiteto<br/>as quis símbolos ou ginástica<br/>símbolos do que chamou Vinicius<br/>“imensos limites da pátria”<br/> <br/>Ou ginástica, para ensinar<br/>Quem for viver naquelas salas<br/>Um deixar-se, um deixar viver<br/>De alma arejada, não fanática<br/> <br/>João Cabral de Melo Neto</span>
                    </div>
                </div>
            </div>
        </div>


        <div 
            class="w-full min-h-screen flex justify-start items-end pl-44 pb-20 bg-cover bg-fixed bg-center relative"
            style={{ backgroundImage: `url(${images.img_3})`}}
        >
            <div className="w-[14.71vw] text-white text-base font-medium font-['Lato']">Oscar Niemeyer - 1958<br/>UCG/IGPA<br/>Jesco von Puttkamer</div>
        </div>

        <div class=" w-full h-auto pt-56 pb-48 px-56 bg-[#f6f8ee]">
              <div className="w-[64.32vw]"><span class="text-black text-xl font-bold font-['Lato']">
                PRECEDENTES<br/></span><span class="text-black text-xl font-medium font-['Lato']"> <br/>Brasília nasceu de um país em movimento. Nas décadas de 50, 60 e 70, o Brasil mudou. O projeto nacional-desenvolvimentista, instaurado por Vargas, teve singular continuidade com Juscelino Kubitschek. A população cresceu fortemente e urbanizou-se. A década de 1950 a 1959 experimentou níveis de crescimento asiáticos, com a segunda melhor média do período pós-46 (7,15%). Neste contexto, a mudança da capital passou a ser a representação mais visível do Programa de Metas de JK, pois simbolizava a interiorização da ocupação econômica do país.<br/><br/>As Constituições de 1891, 1934 e 1946 previam a mudança da capital. No período republicano, o tema tornou-se objeto da atenção de Senadores e Deputados, alimentando a apresentação de propostas legislativas e a atividade de comissões específicas.<br/><br/>A atual localização do Distrito Federal foi fruto destes esforços, consubstanciados em iniciativas do executivo. Na definição da área do DF, Juscelino Kubitscheck homologou o relatório da Comissão de Estudos para a localização da Nova Capital, antes referendado pela Lei n.o 1.803, de cinco de janeiro de 1953. O trabalho dessa Comissão foi refinado por prospecções posteriores, configurando os limites atuais. A primeira iniciativa de localização da futura capital no Planalto Central deve-se, contudo, à </span><span class="text-black text-xl font-bold font-['Lato']">Missão Luiz Cruls</span><span class="text-black text-xl font-medium font-['Lato']">, que, em 1894, demarcou versão reduzida da área definitiva, o quadrilátero Cruls.<br/><br/>A inauguração de Brasília coincidiu com a instalação do Congresso Nacional na nova sede.  Antes de se transferir para o Palácio do Congresso Nacional, o Senado ocupou duas outras sedes. De 1826 a 1925, habitou o antigo Palácio do Conde dos Arcos. Em 1925, mudou-se para o Palácio Monroe, infelizmente demolido.</span>
              </div>
        </div>
        
        <div 
            class="w-full min-h-screen flex justify-start items-end pb-20 pl-40 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_4})`}}
        ></div>

        <div class="h-44 flex justify-start items-end pb-20 pl-40">
            <div className="w-[39.32vw] text-[#170000] text-base font-medium font-['Lato']">Membros da Comissão Exploradora do Planalto Central - Missão Cruls - 1894<br/>Henrique Charles Morize<br/></div>
        </div>

        <div 
            class="w-full min-h-screen flex justify-end items-end pr-24 pb-32 bg-cover bg-fixed bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${images.img_5})`}}
        >
            <div className="w-[15.1vw] text-right text-[#170000] text-base font-medium font-['Lato']">Pedra Fundamental de Brasília<br/>Arquivo Público do DF</div>
        </div>

        <div 
            class="w-full h-auto flex items-center bg-cover bg-center transition-all duration-1000"
            style={{ backgroundImage: `url(${img_next})` }}
        >
            {/* OVERLAY */}
            <div 
                class={`w-full h-screen pl-[7vw] pr-[33.19vw] pt-[45.90vh] pb-[45.80vh] transition-all duration-1000 ${
                    isTransitioning ? 'bg-black/40' : 'bg-[#abb5b0]/70'
                }`}
            >
                <div class="flex gap-6">
                    <div class="flex-col justify-center items-start inline-flex">

                        <div
                            className={`text-3xl font-light font-['Lato'] transition-colors duration-1000 ${
                                isTransitioning ? 'text-white' : 'text-black'
                            }`}
                        >
                            {nextText}
                        </div>
                        <div
                            className={`text-[45px] font-bold font-['Futura Std'] transition-colors duration-1000 ${
                                isTransitioning ? 'text-white' : 'text-black'
                            }`}
                        >
                            O PARLAMENTO E A NOVA CAPITAL
                        </div>
                    </div>
                    <img 
                        class="w-9 h-5 ml-6 mt-auto mb-6 cursor-pointer animate-moveRight transition-transform duration-500 hover:scale-110" 
                        src={seta} 
                        alt='seta'
                        onClick={handleTransition}
                        />
                </div>
            </div>
        </div>
    </div>
  );
}
